import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {VehicleBrand} from '../../domain/core/vehicle-brand.model';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {CustomerWizardResponse} from '../../domain/data/customer-wizard-response.data';
import {EweByMailRequest} from '../../domain/data/ewe-by-mail-request';
import {DigitalSignatureRequest} from '../../domain/data/digital-signature-request';

@Injectable({
  providedIn: 'root',
})
export class WizardService {
  constructor(private http: HttpClient) { }

  getCustomerMailWizardData(brand: string, verificationToken: string): Observable<CustomerWizardResponse> {
    const url = environment.endpoints.getCustomerMailWizardData
      .replace('{brand}', brand)
      .replace('{verificationToken}', verificationToken)
    return this.http.get<CustomerWizardResponse>(url);
  }

  confirmCustomerConsentFromMailWizard(vehicleBrand: VehicleBrand, verificationToken: string, request: EweByMailRequest): Observable<boolean> {
    const url = environment.endpoints.confirmCustomerConsentFromMailWizard
      .replace('{brand}', vehicleBrand.uriName)
      .replace('{verificationToken}', verificationToken);
    return this.http.post<boolean>(url, request);
  }

  getCustomerDigSigWizardData(brand: string, tecCustomerId: string, dealerId: string, userToken: string): Observable<CustomerWizardResponse> {
    const url = environment.endpoints.getCustomerDigSigWizardData
      .replace('{brand}', brand)
      .replace('{tecCustomerId}', tecCustomerId)
      .replace('{dealerId}', dealerId)
      .replace('{userToken}', userToken)
    return this.http.get<CustomerWizardResponse>(url);
  }

  confirmCustomerConsentFromDigSigWizard(tecCustomerId: string, dealerId: string, userToken: string, sendMail: boolean, request: DigitalSignatureRequest): Observable<boolean> {
    const url = environment.endpoints.confirmCustomerConsentFromDigSigWizard
      .replace('{tecCustomerId}', tecCustomerId)
      .replace('{dealerId}', dealerId)
      .replace('{userToken}', userToken)
      .replace('{sendMail}', sendMail.toString());
    return this.http.post<boolean>(url, request);
  }

  denyCustomerConsentFromDigSigWizard(tecCustomerId: string, dealerId: string, userToken: string): Observable<boolean> {
    const url = environment.endpoints.denyCustomerConsentFromDigSigWizard
      .replace('{tecCustomerId}', tecCustomerId)
      .replace('{dealerId}', dealerId)
      .replace('{userToken}', userToken);
    return this.http.get<boolean>(url);
  }

  getDshDocumentPdf(vehicleBrand: VehicleBrand): Observable<ArrayBuffer> {
    const url = environment.endpoints.getDshDocumentPdf
      .replace('{brand}', vehicleBrand.uriName);
    return this.http.get(url, {responseType: 'arraybuffer'});
  }

  confirmCustomerConsentFromWizard(vehicleBrand: VehicleBrand, request: EweByMailRequest) {
    const url = environment.endpoints.confirmCustomerConsentFromWizard
      .replace('{brand}', vehicleBrand.uriName);
    return this.http.post<boolean>(url, request);
  }

  getCustomerWizardData(brand: string): Observable<CustomerWizardResponse> {
    const url = environment.endpoints.getCustomerWizardData
      .replace('{brand}', brand);
    return this.http.get<CustomerWizardResponse>(url);
  }
}
